import { ASSIGNED_DOSSIER_TASK_ROUTE, CLEANING_ROUTE, INVOICING_TASK_ROUTE, MEMO_ROUTE, STACKS_ROUTE, TASK_ROOT_ROUTE } from '../general/router/constants';
import { allPermissions } from '../general/utils/authHelper';
import CommonFilterType from '../shared/constants/CommonFilterType';
import Permission from '../shared/constants/Permission';
import { assignedDossierOverviewLoader, cleaningOverviewLoader, invoicingOverviewLoader, memoOverviewLoader, stackLoader, taskOverviewLoader, taskPageLoader } from './loaders';

const TasksPage = () => import('./views/TasksPage.vue');
const TaskOverview = () => import('./views/TaskOverview.vue');
const AssignedDossiersOverview = () => import('./views/AssignedDossiersOverview.vue');
const PlanningOverview = () => import('./views/PlanningOverview.vue');
const InvoicingOverview = () => import('./views/InvoicingOverview.vue');
const MemoOverview = () => import('./views/MemoOverview.vue');
const CleaningOverview = () => import('./views/CleaningOverview.vue');
const DossierStackView = () => import('./views/DossierStackView.vue');

const CommonTaskOverviewHeader = () => import('./views/CommonTaskOverviewHeader.vue');
const TaskOverviewHeader = () => import('./views/TaskOverviewHeader.vue');
const InvoicingOverviewHeader = () => import('./views/InvoicingOverviewHeader.vue');
const MemoOverviewHeader = () => import('./views/MemoOverviewHeader.vue');
const CleaningOverviewHeader = () => import('./views/CleaningOverviewHeader.vue');

const COMMON_FILTERS = [CommonFilterType.OUTLET_MULTIPLE, CommonFilterType.BRAND_OPTIONAL, CommonFilterType.TEAM_OPTIONAL];
const MEMO_FILTERS = [CommonFilterType.OUTLET_MULTIPLE, CommonFilterType.BRAND_OPTIONAL, CommonFilterType.USER_MULTIPLE];
const CLEANING_FILTERS = [...COMMON_FILTERS, CommonFilterType.USER_MULTIPLE, CommonFilterType.GROUP_MULTIPLE];
const INVOICING_FILTERS = [...COMMON_FILTERS, CommonFilterType.USER_MULTIPLE, CommonFilterType.DOSSIER_TAG];
const DOSSIER_STACKS_FILTERS = [CommonFilterType.OUTLET_MULTIPLE];

export default [
  {
    path: '/tasks',
    component: TasksPage,
    meta: {
      title: 'dossierTasks.pageTitle',
      logicalModule: 'tasks',
      commonFilters: COMMON_FILTERS,
    },
    props: {
      context: taskPageLoader,
    },
    children: [
      {
        path: 'invoicing/:period?',
        name: INVOICING_TASK_ROUTE,
        components: {
          header: InvoicingOverviewHeader,
          content: InvoicingOverview,
        },
        meta: {
          commonFilters: INVOICING_FILTERS,
        },
        props: {
          header: { context: invoicingOverviewLoader },
          content: { context: invoicingOverviewLoader },
        },
      },
      {
        path: 'memos',
        name: MEMO_ROUTE,
        components: {
          header: MemoOverviewHeader,
          content: MemoOverview,
        },
        meta: {
          commonFilters: MEMO_FILTERS,
        },
        props: {
          header: { context: memoOverviewLoader },
          content: { context: memoOverviewLoader },
        },
      },
      {
        path: 'stacks/:stackId',
        name: STACKS_ROUTE,
        meta: {
          commonFilters: DOSSIER_STACKS_FILTERS,
        },
        components: {
          header: CommonTaskOverviewHeader,
          content: DossierStackView,
        },
        props: {
          header: { context: stackLoader },
          content: { context: stackLoader },
        },
      },
      {
        path: 'dossiers',
        name: ASSIGNED_DOSSIER_TASK_ROUTE,
        meta: {
          hasAccess: allPermissions(Permission.FRONTDESK),
        },
        components: {
          header: CommonTaskOverviewHeader,
          content: AssignedDossiersOverview,
        },
        props: {
          header: { context: assignedDossierOverviewLoader },
          content: { context: assignedDossierOverviewLoader },
        },
      },
      {
        path: 'cleaning',
        name: CLEANING_ROUTE,
        components: {
          header: CleaningOverviewHeader,
          content: CleaningOverview,
        },
        meta: {
          commonFilters: CLEANING_FILTERS,
        },
        props: {
          header: { context: cleaningOverviewLoader },
          content: { context: cleaningOverviewLoader },
        },
      },
      {
        path: 'planning',
        name: 'planning-overview',
        meta: {
          hasAccess: allPermissions(Permission.IS_MECHANIC),
        },
        components: {
          header: CommonTaskOverviewHeader,
          content: PlanningOverview,
        },
        props: {
          header: { context: taskPageLoader },
          content: { context: taskPageLoader },
        },
      },
      {
        path: ':category?',
        name: TASK_ROOT_ROUTE,
        components: {
          header: TaskOverviewHeader,
          content: TaskOverview,
        },
        props: {
          header: { context: taskOverviewLoader },
          content: { context: taskOverviewLoader },
        },
      },
    ],
  },
];
